const infoBoldLarge = {
    svg: '<svg style="width:1.50rem; height:1.50rem;" viewBox="0 0 24 24"><path d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12M12.75 8.5V7h-1.5v1.5zm0 8.75v-7h-1.5v7z" clip-rule="evenodd"/></svg>',
};

export { infoBoldLarge as default };
